export const COMPANY = {
  name: "DESP di Sandro Pace",
  shortName: "DESP",
  tagline: "Dove serve, quando serve",
  phone: "3515837771",
  phoneIntl: "+393515837771",
  phoneDisplay: "351 583 7771",
  email: "sandropace@hotmail.it",
  city: "Catania",
  area: "Catania e provincia · Sicilia orientale",
  hours: [
    { days: "Lunedì – Venerdì", time: "08:00 – 18:00" },
    { days: "Sabato", time: "08:00 – 14:00" },
    { days: "Domenica", time: "Chiuso" },
  ],
  whatsappMessage:
    "Ciao DESP, vorrei informazioni sul noleggio di un mezzo. Potete aiutarmi?",
};

export const whatsappUrl = (text = COMPANY.whatsappMessage) =>
  `https://wa.me/${COMPANY.phoneIntl.replace("+", "")}?text=${encodeURIComponent(text)}`;

export const NAV = [
  { label: "Home", to: "/" },
  {
    label: "Parco Mezzi",
    to: "/parco-mezzi",
    children: [
      { label: "Movimento Terra", to: "/parco-mezzi/movimento-terra", desc: "Escavatori, dumper e minipale" },
      { label: "Sollevamento", to: "/parco-mezzi/sollevamento", desc: "Piattaforme aeree e scissor" },
    ],
  },
  {
    label: "Servizi",
    to: "/servizi/noleggio",
    children: [
      { label: "Noleggio", to: "/servizi/noleggio", desc: "A caldo e a freddo, breve e lungo termine" },
      { label: "Trasporto", to: "/servizi/trasporto", desc: "Consegna e ritiro in cantiere" },
    ],
  },
  { label: "Contatti", to: "/contatti" },
];
